import styled from 'styled-components';

export const MobileFilterSection = styled.section`
  padding: 16px 10px;
  display: none;

  @media (max-width: 720px) {
    display: block;
  }
`;

export const MobileFilterTitle = styled.h4`
  font-size: 18px;
  color: hsl(0deg, 0%, 0%, 80%);
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);
  padding-bottom: 12px;
  margin-bottom: 8px;
`;

export const FilterList = styled.ul`
  display: flex;
  align-items: flex-start;
  column-gap: 10px;
  flex-wrap: wrap;

  li {
    background: #f3f3f3;
    border-radius: 14px;
    padding: 6px 14px;
    margin: 10px 0 6px;
    font-size: 14px;
    font-weight: 500;
    color: rgb(0 0 0 / 70%);
  }
  .selected {
    background: #63b0a8;
    color: #fff;
  }
`;
